import { errorMessage as sharedErrorMessage } from '@central/ui';

const messages: Record<string, string> = {
  stale_rev: 'Someone saved this license after you opened it.',
  visibility_locked: 'Shared environments keep this item off.',
  not_pending: 'This environment is no longer waiting for approval.',
  not_enrolled: 'This environment is not enrolled.',
  revoke_first: 'Revoke this environment before archiving it.',
  archived: 'This environment is archived. Unarchive it first.',
  already_member: 'That address is already on the team.',
  published: 'This announcement is already published; only its end date can change.',
  last_factor: 'This is your only second factor. Add another before removing it.',
  last_owner:
    'The last enabled Owner cannot be disabled or demoted. Make someone else an Owner first.',
  last_reseller_admin:
    'A reseller must keep at least one enabled admin who has signed in. Make someone else an admin first.',
  self_change: 'You cannot disable yourself or remove your own admin rights. Ask another admin.',
  user_disabled: 'This user is disabled. Enable them before sending a link.',
  self_recovery: 'You cannot reset your own second factors. Ask another Owner.',
  activation_limit:
    'Not enough free activations on this license. Raise allowed activations or revoke one first.',
};

/**
 * Operator-facing text for an error, chosen by the server's code. `overrides`
 * words a code only one screen can mean (a 409 `duplicate` names what already
 * exists); they win over the console-wide text.
 */
export function errorMessage(err: unknown, overrides: Record<string, string> = {}): string {
  return sharedErrorMessage(err, { ...messages, ...overrides });
}
